import axios from 'axios';
import { isTokenExpired } from '../utils/auth';
import { logout } from '../services/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

// Interceptor para agregar encabezados antes de cada petición
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken');
    const excludedRoutes = [
      '/auth/login',
      '/auth/signin',
      '/shared-report',
      '/survey_shares/getByToken',
      '/surveys/getSurveyById',
      '/surveys/getAll',
      '/responses/getAll',
      '/responses/getBySurveyId',
      '/responses/getOpenResponsesBySurveyId',
      '/reports/getSurveyResponseStats',
      '/reports/getQuestionOptionStats',
      '/reports/getSurveyResponses',
      '/reports/getLastCompleteSurveyResponse',
      '/reports/getResponsesByDay',
      '/reports/getTopResponseHours'
    ]; // Rutas que no requieren token
    // Excluir rutas específicas de la verificación del token
    if (!excludedRoutes.some(route => config.url.includes(route))) {
      if (isTokenExpired(token)) {
        console.log('El token ha expirado. Cerrando sesión...');
        logout(); // Cierra la sesión si el token ha expirado
        return Promise.reject(new Error('Token expirado. Sesión cerrada.'));
      }
    }
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['Time-Zone'] = userTimeZone;

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;
